import { Model } from '@/models/Model';
export class LogKey extends Model {
    constructor() {
        super(...arguments);
        this.active = false;
        this.$name = 'LogKey';
        this.$endpoint = '/logs/keys';
        this.$fillable = [];
    }
}
